<div class="wrapper-single-list-page">
  <div class="header-page">
    <img src="../../../../assets/icons/logo-horizontal-yellow.svg" alt="">
    <div class="options-header-right">
      <button class="custom-btn custom-btn--gray" [routerLink]="[PAGES_AND_PATHS.createAccount.pagePath]">
        <span>{{ 'GENERAL.sign_up' | translate }}</span>
      </button>
      <button class="custom-btn custom-btn--primary" [routerLink]="[PAGES_AND_PATHS.login.pagePath]">
        <span>{{ 'GENERAL.login' | translate }}</span>
      </button>
    </div>
  </div>
  <div class="wrapper-content-single-page">
    <div class="wrapper-header-single-list">
      <div class="header-single-list">
        <div class="wrapper-info-single-list">
          <div class="wrapper-img-single-list">
            <img [ngSrc]="list?.lyst_image_url !== null ? list?.lyst_image_url : 'assets/images/no-image.png'" alt="" width="215" height="175">
          </div>
          <div class="tl-d-flex tl-flex-column">
            <div class="info-single-list">
              <div class="wrapper-badges">
                <div class="badge yellow">
                  <span>{{ list?.lyst_items_count }} {{ 'LISTS.items' | translate }}</span>
                </div>
              </div>
              <app-item-rating *ngIf="((list?.user?.subscriptions | checkActiveRole) === UserRoles.expert || (list?.user?.subscriptions | checkActiveRole) === UserRoles.company)"
                               [averageRating]="list?.average_rating"
                               [reviewsCount]="list?.reviews_count"></app-item-rating>
            </div>
            <span class="title-single-list">{{ list?.title }}</span>
            <div class="wrapper-info-author-list">
              <div class="wrapper-image-author-list">
                <img *ngIf="(list?.user?.subscriptions | checkActiveRole) !== UserRoles.expert"
                     [ngSrc]="list?.user?.profile_photo_url !== null ? list?.user?.profile_photo_url :  '../../../../assets/images/avatar-user.png'"
                     alt="" width="32" height="32">
                <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert"
                     [ngSrc]="list?.user?.profile_photo_url !== null ? list?.user?.profile_photo_url : '../../../../assets/images/avatar-user-expert.png'"
                     alt="" width="32" height="32">
              </div>
              <div class="info-author-list">
                <div class="wrapper-username">
                  <span>{{ list?.user.name }}</span>
                  <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../../assets/icons/fill/icon-badge.svg" alt="">
                  <img *ngIf="(list?.user?.subscriptions | checkActiveRole) === UserRoles.company" src="../../../../assets/icons/fill/icon-fill-company.svg" alt="">
                </div>
                <div class="tl-d-flex tl-align-center">
                  <span class="date-list">
                    <p>{{ 'NEW_TEXT.created_at' | translate }}</p>{{ list?.created_at | date:'d MMMM y' }},</span>
                  <span
                    class="date-list"><p>{{ 'NEW_TEXT.updated_at' | translate }}</p>{{ list?.updated_at | date:'d MMMM y' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-likes-and-more-btn">
          <div class="wrapper-likes">
            <button (click)="isModalOpen = true" class="custom-btn custom-btn--circle-outline">
              <img *ngIf="!list?.am_i_favorite_this_lyst" class="no-like"
                   src="../../../../assets/icons/outline/icon-heart.svg" alt="">
              <img *ngIf="list?.am_i_favorite_this_lyst" class="like" src="../../../../assets/icons/fill/icon-heart.svg"
                   alt="">
            </button>
            <span (click)="isModalOpen = true">{{ list?.favorite_users_count }}
              {{ list?.favorite_users_count === 1 ? ('LISTS.like' | translate) : ('LISTS.likes' | translate) }}</span>
            <button (click)="isModalOpen = true"
                    class="custom-btn custom-btn--outline-white">
              <img src="./assets/icons/outline/icon-plus.svg" alt="">
              <span>{{ 'LIST_SINGLE_PAGE.copy_to_my_lists' | translate }}</span>

            </button>
          </div>
          <div class="wrapper-dropdown-btn">
            <button (click)="isModalOpen = true" class="custom-btn custom-btn--circle-outline">
              <img src="../../../../assets/icons/outline/icon-view-more.svg" alt="">
            </button>
          </div>
        </div>
        <div class="wrapper-custom-tabs">
          <div class="custom-tab active">
            <img src="../../../../../assets/icons/outline/icon-my-lists.svg" alt="">
            <span>
              {{ 'LIST_SINGLE_PAGE.items' | translate }}
            </span>
          </div>
          <div class="custom-tab" (click)="isModalOpen = true">
            <img src="../../../../../assets/icons/outline/icon-posts.svg" alt="">
            <span>
              {{ 'GENERAL.posts' | translate }}
            </span>
          </div>
          <div *ngIf="((list?.user?.subscriptions | checkActiveRole) === UserRoles.expert || (list?.user?.subscriptions | checkActiveRole) === UserRoles.company)" (click)="isModalOpen = true"
               class="custom-tab">
            <img src="../../../../assets/icons/outline/icon-review.svg" alt="">
            <span>
              {{ 'GENERAL.reviews' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper-content-single-list">
      <div class="content-single-list">
        <app-items
          [items]="items"
          [columns]="columns"
          [user_id]="list?.user_id"
          (searchTermChanged)="onSearchTermChanged($event)"
          (openPublicListModal)="isModalOpen = true"
        ></app-items>
      </div>
    </div>
  </div>
  <!--  Footer purple box  -->
  <div class="wrapper-purple-box">
    <div class="purple-box-info">
      <span class="title-purple-box">{{ 'NEW_TEXT_TRANSLATE.preview_of_the_lysts' | translate }}</span>
      <span class="subtitle-purple-box">{{ 'NEW_TEXT_TRANSLATE.sign_up_to_get_unlimited_access_to_lists_and_all_features_of_our_app' | translate }}.</span>
    </div>
    <button class="custom-btn custom-btn--white" [routerLink]="[PAGES_AND_PATHS.createAccount.pagePath]"><span>{{ 'NEW_TEXT_TRANSLATE.sign_up_for_free' | translate }}</span></button>
  </div>
</div>

<tl-public-list-modal
  *ngIf="isModalOpen"
  (closeModal)="isModalOpen = false"
></tl-public-list-modal>



